/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

export const ENTER_KEY = 'Enter';
export const ENTER_KEYCODE = 13;
export const ESCAPE_KEY = 'Escape';
export const ESCAPE_KEYCODE = 27;
export const SPACE_KEY = ' ';
export const SPACE_KEYCODE = 32;
export const TAB_KEY = 'Tab';
export const TAB_KEYCODE = 9;
